import { useLocation } from 'react-router-dom';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { AppUIActions } from 'app/store/AppUI/AppUI.slice';
// Selectors
import { selectFilesSidebarOpen, selectWorkspaceSidebarOpen } from 'app/store/AppUI/AppUI.selectors';
// Components
import SidebarToggleButton from 'app/components/SidebarToggleButton';
// Mixpanel
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

const SidebarToggle = () => {
  const { pathname } = useLocation<{ pathname:string }>();
  const isWorkspacePath = pathname.includes('workspace');

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const filesSidebarOpen = useAppSelector(selectFilesSidebarOpen);
  const workspaceSidebarOpen = useAppSelector(selectWorkspaceSidebarOpen);

  const open = isWorkspacePath ? workspaceSidebarOpen : filesSidebarOpen;

  const handleToggleFilesSidebar = () => {
    const type = isWorkspacePath ? 'workspace' : 'files';

    dispatch(AppUIActions.toggleBatchesSidebar({ type }));

    if ( open ) {
      dispatch(MixpanelActions.handleCaseDocumentsNavBarClosedClick());
    } else {
      dispatch(MixpanelActions.handleCaseDocumentsNavBarOpenedClick());
    }
  }

  return (
    <SidebarToggleButton
      name={isWorkspacePath ? 'Workspace sidebar toggle button' : 'Files sidebar toggle button'}
      open={open}
      onClick={handleToggleFilesSidebar}
    />
  )
}

export default SidebarToggle;
